import getApi from "../api/getApi";
import postApi from "../api/postApi";
import * as url from "../api/url";

// Post Contact us Api
export const getTestimonial = (payload) => {
  return new Promise(async (resolve, reject) => {
    return postApi
      .post(url.GET_TESTIMONIAL, payload)
      .then((response) => {
        if (response) {
          resolve(response);
        }
      })
      .catch((err) => {
        reject(err.response);
      });
  });
};
